import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { ISimulationInput } from 'components/generics/Interface/Simulation/ISimulationInput';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { lastSimulate } from 'services/API/Simulation';
import useAuth from 'providers/Auth/useAuth';
import { IUser, RolesNames } from 'components/generics/Interface/Api/Response/User/IUser';

type SelectSimuOtherUserParams = {
  isSimulationContextUpdated: boolean;
  updateSimulationParams: (simulation: SimulationData | undefined) => void;
  exploitationId: number;
};

type SimulationData = {
  user: IUser;
  id: number;
  simulation: ISimulationInput;
};

const SelectSimuOtherUser = ({
  isSimulationContextUpdated,
  updateSimulationParams,
  exploitationId,
}: SelectSimuOtherUserParams): React.JSX.Element => {
  const { user } = useAuth();
  const [otherUsersList, setOtherUserList] = useState<SimulationData[] | null>(null);
  const [selectedSimu, setSelectedSimu] = useState<number | ''>('');

  useEffect(() => {
    if (exploitationId && isSimulationContextUpdated) {
      lastSimulate(exploitationId)
        .then((res) => {
          const currentUserLastSimulate = res.data.data.find(
            (simu: any) => simu.user.id === user.id
          );
          updateSimulationParams(currentUserLastSimulate);
          const currentUserLastSimulateId = currentUserLastSimulate?.id || '';
          setSelectedSimu(currentUserLastSimulateId);
          setOtherUserList(res.data.data);
        })
        .catch((err) => {
          toast.error(err?.response?.data?.message);
        });
    }
  }, [isSimulationContextUpdated]);

  const handleSimuChange = (event: SelectChangeEvent<number>) => {
    setSelectedSimu(Number(event.target.value));
    const simuParams = otherUsersList?.find((simu) => simu.id === event.target.value);
    updateSimulationParams(simuParams);
  };

  return user?.role === RolesNames.SUPER_ADMIN ? (
    <FormControl size="small" sx={{ minWidth: 200, maxWidth: 250 }}>
      <InputLabel id="select_other_user_simu_label">Choisir un utilisateur</InputLabel>
      <Select
        labelId="select_other_user_simu_label"
        autoWidth
        label="Choisir un utilisateur"
        id="select_other_user_simu"
        name="select_other_user_simu"
        value={selectedSimu}
        onChange={(e: SelectChangeEvent<number>) => handleSimuChange(e)}
      >
        {otherUsersList?.map((simulationData) => (
          <MenuItem key={simulationData.id} value={simulationData.id}>
            {simulationData.user.firstname + ' ' + simulationData.user.lastname}
          </MenuItem>
        ))}
        {otherUsersList?.length === 0 && (
          <MenuItem key={0} value={0} disabled>
            Aucune simulation disponible
          </MenuItem>
        )}
      </Select>
    </FormControl>
  ) : (
    <></>
  );
};

export default SelectSimuOtherUser;
